const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  // const scaleAmount = 0.2 / 100;
  const scaleAmount = 1 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    // element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));   
    element.style.setProperty('--zoom-in-ratio', 0.6 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        // element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

        // custom code
        let counter = 0.6 + scaleAmount * percentageSeen(element);
        if (counter > 0.99) counter = 1;

        let opacityCounter = scaleAmount * percentageSeen(element);
        let imageVisible = percentageSeen(element);

        let initOpacity = 0;

        if(imageVisible > 40 && imageVisible < 66) {
          if(imageVisible >= 40) initOpacity = 0.05;
          if(imageVisible >= 41) initOpacity = 0.1;
          if(imageVisible >= 42) initOpacity = 0.15;
          if(imageVisible >= 43) initOpacity = 0.2;
          if(imageVisible >= 44) initOpacity = 0.25;          
          if(imageVisible >= 45) initOpacity = 0.3;
          if(imageVisible >= 46) initOpacity = 0.35;
          if(imageVisible >= 47) initOpacity = 0.4;
          if(imageVisible >= 48) initOpacity = 0.45;
          if(imageVisible >= 49) initOpacity = 0.5;
          if(imageVisible >= 50) initOpacity = 0.55;
          if(imageVisible >= 51) initOpacity = 0.6;
          if(imageVisible >= 52) initOpacity = 0.65;
          if(imageVisible >= 53) initOpacity = 0.7;
          if(imageVisible >= 54) initOpacity = 0.75;
          if(imageVisible >= 55) initOpacity = 0.8;
          if(imageVisible >= 56) initOpacity = 0.85;
          if(imageVisible >= 58) initOpacity = 0.88;
          if(imageVisible >= 60) initOpacity = 0.9;
          if(imageVisible >= 62) initOpacity = 0.93;
          if(imageVisible >= 64) initOpacity = 0.96;
          if(imageVisible >= 66) initOpacity = 1;
          
          element.querySelector('.image-1').style.opacity = 1 - initOpacity;
          element.querySelector('.image-2').style.opacity = initOpacity;
        }
        
        element.style.setProperty('--zoom-in-ratio', counter);
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  // stop counting when bottom of the element is visible
  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
